<template>
  <mdb-container>
    <EditAdvertisement :default-marker="marker" :copy="true" />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditAdvertisement from "@/components/EditAdvertisement.vue";

export default {
  name: "CopyAdvertisement",
  components: {
    mdbContainer,
    EditAdvertisement,
  },
  data() {
    return {
      marker: {
        name: "Helsinki",
        position: { lat: 60.1733244, lng: 24.9410248 },
        radius: 0,
      },
    };
  },
};
</script>
